import { createApp, nextTick } from 'vue';
import App from './App.vue';
// import router from './router';
import { setupRouter } from './router';
import { i18n } from './i18n';
import requireImage from '@/utils/requireImage';
import {
  setupVant,
  setupStore,
  setupIonic,
  setupAssets,
  setupIonicStorage,
  // setupScreenOrientation,
  setupStatusBar,
  // setupAndroidNotch,
} from './plugins';
import setupComponents from './plugins/components';
// import { SplashScreen } from '@capacitor/splash-screen';

import './styles/iconfont/iconfont.css'; // 字体图标
import './styles/atom.scss'; // 基础样式

import 'virtual:windi.css';
import './styles/index.css';

/* Theme variables */
import './theme/variables.css'; // 主题样式
import VueLuckyCanvas from '@lucky-canvas/vue';
import { useTokenStore, useUserStore } from './store/user.js';
import { useChatHistoryStore } from './store/chatHistory.js';
import { useAppStore } from './store/app.js';

async function setupApp() {
  // 禁用横屏
  // setupScreenOrientation();

  // 安卓安全区距离
  // setupAndroidNotch();


  // await SplashScreen.show({
  //   showDuration: 5000,
  //   autoHide: true,
  // });

  // 引入静态资源依赖(js,css)
  setupAssets();

  // 状态栏沉浸
  setupStatusBar();
  await setupIonicStorage();

  const app = createApp(App);
  setupStore(app);

  const userStore = useUserStore();
  await userStore.syncUser();

  const appStore = useAppStore();
  await appStore.syncLang(); // i18n

  const token = useTokenStore();
  await token.syncToken();

  const chatHistoryStore = useChatHistoryStore();
  await chatHistoryStore.reloadForCurrentUser();

  setupVant(app);
  // 挂载ionic框架
  setupIonic(app);
  app.use(i18n);
  app.use(VueLuckyCanvas);
  app.config.globalProperties.$requireImg = requireImage;
  // 挂载路由
  await setupRouter(app);
  setupComponents(app);
  // 路由准备就绪后挂载APP实例
  app.mount('#app');
  // setTimeout(() => {
  //   SplashScreen.hide();
  // }, 1000);

  // 关闭启动屏
  nextTick(() => {
    // 阻止双指缩放（监听手势事件）
    document.addEventListener(
      'gesturestart',
      (e) => {
        e.preventDefault();
      },
      { passive: false },
    );

    document.addEventListener(
      'gesturechange',
      (e) => {
        e.preventDefault();
      },
      { passive: false },
    );

    // 阻止双击缩放（监听触摸结束事件，判断短时间内的两次触摸）
    let lastTouchEnd = 0;
    document.addEventListener(
      'touchend',
      (e) => {
        const now = Date.now();
        // 300ms内连续触发touchend视为双击，阻止默认行为
        if (now - lastTouchEnd <= 300) {
          e.preventDefault();
        }
        lastTouchEnd = now;
      },
      { passive: true },
    );

    // 额外防护：防止视觉视口意外缩放后强制重置
    window.visualViewport?.addEventListener('resize', () => {
      if (window.visualViewport?.scale !== 1) {
        document.documentElement.style.transform = 'scale(1)';
      }
    });
  });
}

setupApp();
